import angular from 'angular';

angular.module('commonServices').factory('appMessages', ['$translate', appMessages]);

function appMessages($translate) {
  return function(msgString, params) {
    switch (msgString) {
      case 'SuccessTitle':
        return $translate.instant('Success');
      case 'ErrorTitle':
        return $translate.instant('Error');
      case 'WarningTitle':
        return $translate.instant('Warning');
      case 'ChangesSaved':
        return $translate.instant('ChangesSaved'); // 'Changes saved...'
      case 'msgConfirmChange':
        return $translate.instant('msgConfirmChange'); // 'Changes saved...'
      case 'msgItemRemoved':
        return $translate.instant('msgItemRemoved'); // 'Item removed...'
      case 'msgConfirmDeleteTitle':
        return $translate.instant('Delete?'); // 'Changes saved...'

      case 'msgNewItemSaved':
        return $translate.instant('msgNewItemSaved');
      case 'msgCommSaved':
        return $translate.instant('msgCommSaved'); // commSetting opgeslagen
      case 'msgCommRemoved':
        return $translate.instant('msgCommRemoved'); // commSetting verwijderd
      case 'msgLinkRemoved':
        return $translate.instant('msgLinkRemoved'); // Link removed
      case 'msgEmpRemoved':
        return $translate.instant('msgEmpRemoved'); // Employee removed
      case 'msgAddressRemoved':
        return $translate.instant('msgAddressRemoved'); // Adres verwijderd
      case 'msgLinkSaved':
        return $translate.instant('msgLinkSaved'); // Link saved
      case 'msgRemoved_name':
        return $translate.instant('msgRemoved_name', params); //
      case 'msgInactive_name':
        return $translate.instant('msgInactive_name', params); // {{name}} set to inactive
      case 'msgNewRelCreated':
        return $translate.instant('msgNewRelCreated');
      case 'msgNewEmpCreated':
        return $translate.instant('A new user was created and a confirmation mail sent.');
      case 'Registration created':
        return $translate.instant('Registration created');
      case 'Edit registration':
        return $translate.instant('Edit registration');
      case 'Because of linked invoices/registrations.':
        return $translate.instant('Because of linked invoices/registrations.');
      case 'Undo/Make active':
        return $translate.instant('Undo/Make active');
      case 'Registration modified':
        return $translate.instant('Registration modified');
      case 'Registration removed':
        return $translate.instant('Registration removed');
      case 'Line added':
        return $translate.instant('Line added');
      case 'Field config modified':
        return $translate.instant('Field config modified');
      case 'Field config removed':
        return $translate.instant('Field config removed');
      case 'Field config added':
        return $translate.instant('Field config added');
      case 'Field added':
        return $translate.instant('Field added');
      case 'Field updated':
        return $translate.instant('Field updated');
      case 'msgSingleInvoiceEmailSent':
        return $translate.instant('Invoice for {{relation}} sent', params);
      case 'msgInvoiceMarkedAsSent':
        return $translate.instant('The invoice is marked as sent');
      case 'msgCreditNoteMarkedAsSent':
        return $translate.instant('The credit note is marked as sent');
      case 'msgXDraftInvoicesChanged':
        return $translate.instant('{{p0}} draft invoices have been changed', params);
      case 'msgIncompleteEntryInMaskIsNoSave':
        return $translate.instant('msgIncompleteEntryInMaskIsNoSave');
      case 'comfirmTitle':
        return $translate.instant('Are you sure?');
      case 'comfirmDeleteTitle':
        return $translate.instant('Delete?');
      case 'comfirmDisableNotificationType':
        return $translate.instant('Turn of notifications of this type ?');
      case 'comfirmDeleteItem':
        return $translate.instant('Are you sure you want to delete this item?');
      case 'comfirmDeletePayment':
        return $translate.instant('Are you sure you want to delete this payment?');
      case 'comfirmDeleteInvoice':
        return $translate.instant('Are you sure you want to delete this invoice?');
      case 'comfirmUndoInvoice':
        return $translate.instant('Are you sure you want to undo this invoice?');
      case 'comfirmDeleteInvoiceLine':
        return $translate.instant('Are you sure you want to delete this invoice line?');
      case 'comfirmUndoInvoiceDetailLine':
        return $translate.instant('Are you sure you want to undo this detail line?');
      case 'comfirmUndoOrNeverInvoiceDetailLine':
        return $translate.instant(
          'Are you sure you want to undo this detail line? Or never invoice it again?',
        );
      case 'comfirmUndoOrNeverInvoiceRegistrations':
        return $translate.instant(
          'Are you sure you want to undo all selected registrations? Or never invoice it again?',
          params,
        );
      case 'comfirmUndoOrNeverInvoiceLine':
        return $translate.instant(
          'Are you sure you want to delete this invoice line? All registrations will be moved to the next invoice or you can choose to never invoice them again?',
        );
      case 'comfirmDeleteInvoiceDetailLine':
        return $translate.instant('Are you sure you want to delete this detail line?');
      case 'comfirmDeleteTranslation':
        return $translate.instant('Are you sure you want to delete this translation?');
      case 'comfirmDeleteTemplate':
        return $translate.instant('Are you sure you want to delete this template?');
      case 'comfirmDeleteReminder':
        return $translate.instant('Are you sure you want to delete this reminder?');
      case 'comfirmDeleteResource':
        return $translate.instant(
          'Are you sure you want to delete this resource "{{name}}"?',
          params,
        );
      case 'msgConfirmDeleteTaskSchedule':
        return $translate.instant('Are you sure you want to delete this task schedule?');
      case 'msgConfirmDeleteTaskScheduleLine':
        return $translate.instant('Are you sure you want to delete this task schedule line?');
      case 'msgConfirmDeleteDocument':
        return $translate.instant('Are you sure you want to delete this document?');

      case 'msgConfirmDeleteDocumentOrLink':
        return $translate.instant(
          'Do you want to delete the document (yes). Or delete the link but keep the document (no).',
        );
      case 'confirmDeleteInvoiceText':
        return $translate.instant('Are you sure you want to delete this invoice text?');
      case 'linkTransSuccess':
        return $translate.instant(
          'Link successfull, payment created for invoice {{invNr}}',
          params,
        );
      case 'linkTransMultiple':
        return $translate.instant('{{nr}} possible matching invoices found', params);
      case 'linkTransFailed':
        return $translate.instant('No matching invoices found');
      case 'mapsOriginNotFound':
        return $translate.instant('Origin address not found');
      case 'mapsDestinationNotFound':
        return $translate.instant('Destination address not found');
      case 'msgPagingNoResults':
        return $translate.instant('Query returned no results');
      case 'msgPagingNoInvoiceResults':
        return $translate.instant('Query returned no invoices');
      case 'msgPagingNoResourceResults':
        return $translate.instant('Query returned no resources');

      case 'msgInvoiceProcessed':
        return $translate.instant('The invoice for {{name}} is being processed.', params);
      case 'msgExporterMissingAccNr':
        return $translate.instant(
          'Export is not possible: there are missing accounting numbers in some relation files. Click to open these files.',
        );
      case 'msgExporterMultipleCompanies':
        return $translate.instant(
          'You can only export invoices for 1 own company, use the own company filter in the advanced filters.',
        );
      case 'msgInvoiceCountProcessed':
        return $translate.instant('{{count}} invoices are being processed.', params);
      case 'msgInvoiceCountDateToNumber':
        return $translate.instant('{{count}} invoices will be numbered on {{date}}', params);
      case 'msgInvoiceCountErrors':
        return $translate.instant('{{count}} invoices have errors.', params);
      case 'msgPositiveCreditNotesOrViceVersaCount':
        return $translate.instant(
          '{{count}} invoices are positive creditnotes and vice versa and we ask you to finalize these invoices individually.',
          params,
        );
      case 'btnOpenRelation':
        return $translate.instant('Open relation');
      case 'cancel':
        return $translate.instant('Cancel');
      case 'newCustomer':
        return $translate.instant('New customer');
      case 'newRelation':
        return $translate.instant('New relation');
      case 'msgRegistrationCreated':
        return params.relation + ' - ' + params.resource;
      case 'msgTaskTimeRegistrationCreated':
        return (
          $translate.instant('Registered {{duration}} for {{relation}}', params) +
          ' - ' +
          $translate.instant('Click here to edit')
        );
      case 'msgTaskTimeRegistrationDiscarded':
        return $translate.instant('Registration discarded (less than 1 minute)');
      case 'msgCODAProcessed':
        return $translate.instant(
          'The CODA file has been processed. {{n}} transactions have been created.',
          params,
        );
      case 'msgFieldsNeededCompleteFile':
        return $translate.instant(
          'The following fields are needed to complete this file: {{list}}',
          params,
        );

      case 'msgCompanyFillInEnterpriseNrCBE':
        return $translate.instant(
          'Fill out your enterprise number and the other data for your company will be fetched from the CBE.',
        );
      case 'btnEditEnterpriceNr':
        return $translate.instant('Edit');
      case 'msgCompanyCBENotFound':
        return $translate.instant('This enterprise number could not be found in the CBE database.');
      case 'msgInvalidPhoneNumber':
        return $translate.instant('Please enter a valid phone number');
      case 'msgDownloadingFile':
        return $translate.instant(
          'Your download is being prepared. This could take a few moments.',
        );

      case 'msgNegativeDiscountWarning':
        return $translate.instant('A discount is saved as a positive number.');
      case 'msgApplyDiscountsToInvoices':
        return $translate.instant('Apply the new discount to existing invoice proposals?');
      case 'msgCannotSendNoRelationEmail':
        return $translate.instant(
          'Invoice can only be sent if you add an emailaddress to the relation file.',
        );
      case 'msgUpdateDraftInvoicesTitle':
        return $translate.instant('Update draft invoices?');

      case 'msgTemplateNotInLanguage':
        return $translate.instant('There is no mail template for the language of this customer.');
      case 'msgChangeInvoiceStreamScheduleTitle':
        return $translate.instant('Update invoice schedule');
      case 'msgInvoiceStreamChangeExistingSchedules':
        return $translate.instant('Do you want to update the existing lines accordingly?');
      case 'msgDeleteInvoiceStreamScheduleLine':
        return $translate.instant('Are you sure you want to delete this invoice schedule line?');
      case 'msgInvoiceStreamScheduleLineDeleted':
        return $translate.instant('Invoice schedule line deleted');
      case 'msgDeleteBudget':
        return $translate.instant('Are you sure you want to delete this budget line?');
      case 'msgDeletePlannedRegistrationLine':
        return $translate.instant(
          'Are you sure you want to delete this planned registration line?',
        );
      case 'msgPlannedRegistrationLineDeleted':
        return $translate.instant('Planned registration line deleted');
      case 'msgDeletePlannedRegistration':
        return $translate.instant('Are you sure you want to delete this planned registration?');
      case 'msgRegistrationRemoved':
        return $translate.instant('Planned registration deleted');

      case 'msgTaskPlannedOn':
        return $translate.instant(
          'The task {{name}} has been planned with deadline {{deadline}}',
          params,
        );
      case 'msgRelationsWithSameAccountingNr':
        return $translate.instant('This accounting number is already in use for: {{p0}}', params);
      case 'msgRelationsSameCustomerCode':
        return $translate.instant('This code is already in use for: {{p0}}', params);
      case 'msgConfirmDeleteRegistration':
        return $translate.instant('Are you sure you want to delete this registration?');
      case 'msgConfirmDeleteTimeTable':
        return $translate.instant(
          'Are you sure you want to delete the time table for this employee?',
        );
      case 'msgConfirmResetTwoFaTitle':
        return $translate.instant('Reset two-factor authentication?');
      case 'msgConfirmResetTwoFa':
        return $translate.instant(
          'The user will receive an e-mail about the reset and will have to configure 2FA again. Please advise the user to delete their 2FA token from their authenticator app before setting up 2FA again.',
        );
      case 'msgDeleteTaskSchedule':
        return $translate.instant('Delete task schedule');
      case 'msgDeleteTransaction':
        return $translate.instant('Are you sure you want to delete this transaction?');
      case 'msgDeleteTaskScheduleAlsoDeletePlannedTasks':
        return $translate.instant(
          'Do you want the remove the tasks linked to this schedule from the taskboard?',
        );
      case 'msgEmployeeRestoreSuccesful':
        return $translate.instant('Employee restored');
      case 'confirmDeleteInvoiceAttachment':
        return $translate.instant(
          'Are you sure you want to delete this attachment from this invoice?',
        );
      case 'confirmDeleteEmailAttachment':
        return $translate.instant(
          'Are you sure you want to delete this attachment from this email?',
        );
      case 'confirmDeleteAttachment':
        return $translate.instant('Are you sure you want to delete this attachment?');
      case 'msgInvoiceScheduleExistingLinesBeforeStartDateNotDeleted':
        return $translate.instant(
          'New settings apply from the entered date. If existing schedule lines before this date should not be executed, you need to remove them manually.',
        );
      case 'msgRelationUpdated':
        return $translate.instant('Relation updated successfully.');
      case 'msgPaymentProviderChangedSuccess':
        return $translate.instant('Payment details for {{provider}} saved sucessfully.', params);
      case 'msgChangeTwikeyAccountNumberSuccess':
        return $translate.instant('Request to change Twikey account number submitted succesfully.');
      case 'msgChangeTwikeyAccountNumberError':
        return $translate.instant(
          'Something went wrong while submitting your request to change Twikey account number. Please try again.',
        );
      case 'msgModuleConfigurationSaved':
        return $translate.instant('Module configuration saved');
      case 'msgTaskTemplateCopied':
        return $translate.instant('Task template copied');
      case 'msgRequiredField':
        return $translate.instant('Dit veld is verplicht.'); // Key is in dutch

      case 'msgNumberLicensesLowerThanEmployees':
        return $translate.instant(
          "The number of licenses can't be lower than the number of employees. Please remove (an) employee(s) with a user account first.",
        );
      case 'msgConfirmAddInvoiceTemplate':
        return $translate.instant('Invoice template added');
      case 'msgConfirmDeleteInvoiceTemplate':
        return $translate.instant('Are you sure you want to delete this template?');
      case 'msgConfirmDeleteRelationLink':
        return $translate.instant('Are you sure you want to delete this link?');
      case 'msgConfirmChangePaymentProvidertitle':
        return $translate.instant('Change payment provider');
      case 'msgConfirmChangePaymentProvider':
        return $translate.instant('Are you sure you want to change your payment provider?');
      case 'msgJobStarted':
        return $translate.instant(
          'A background job has started. Click here to monitor the progress.',
        );
      case 'msgJobFinished':
        return $translate.instant('A background job has finished.');
      case 'msgJobFailed':
        return $translate.instant('A background job has failed');
      case 'msgPropogateTaskTemplateChangesCount':
        return $translate.instant(
          '{{count}} task(s) on the taskboard have been updated accordingly.',
          params,
        );
      case 'msgConfirmPropogateTemplateChangesTitle':
        return $translate.instant('Update task template');
      case 'msgInvoicesSentToConnect':
        return $translate.instant('Invoices sent to connect service.');
      case 'msgConfirmPropogateTemplateChanges':
        return $translate.instant(
          'Do you want to apply the changes to the tasks on the taskboard linked to this template?',
        );
      case 'msgConfirmPropagateSubtaskTemplateDelete':
        return $translate.instant(
          'Do you also want to delete the subtasks on the taskboard linked to this template?',
        );
      case 'msgConfirmPropagateTemplateDelete':
        return $translate.instant(
          'Do you also want to delete the tasks on the taskboard linked to this template?',
        );
      case 'msgAddedRegistrationToDraftInvoice':
        return $translate.instant('Registration added to draft invoice.');
      case 'msgRemovedRegistrationFromDraftInvoice':
        return $translate.instant('Registration removed from draft invoice.');
      case 'msgInvoiceRegistrationNoInvoiceCreated':
        return $translate.instant(
          'There was no draft invoice created for this registration because of the invoice schedule of this relation.',
        );
      case 'msgRegistrationMovedToOtherDraftInvoice':
        return $translate.instant('The registration was moved to another draft invoice');
      case 'msgClickToOpenDraftInvoice':
        return $translate.instant('Click to open the draft invoice');
      case 'msgConfirmDeleteEmployeeProfile':
        return $translate.instant(
          'Are you sure you want to delete this employee profile? All employees linked to this profile will be assigned to the default profile.',
        );
      case 'msgConfirmPropogateChangesTitle':
        return $translate.instant('Propogate changes');
      case 'msgConfirmPropogateResourceForfaitChanges':
        return $translate.instant(
          'Do you want to propogate this change to all open registrations?',
        );

      case 'msgChooseExistingTeamFromList':
        return $translate.instant(
          'Please enter an existing team. A new team can be created in the settings.',
        );
      case 'msgTeamListEmpty':
        return $translate.instant(
          "You've cleared the list of teams. This relation will now be visible to everyone.",
        );
      case 'msgConfirmDeleteUBOVerification':
        return $translate.instant('Are you sure you want to delete this UBO verification?');
      case 'msgDeleteTaskParameter':
        return $translate.instant(
          'Are you sure you want to delete this task parameter? It will no longer be available in email templates and tasks using this parameter.',
        );
      case 'msgStartEndDateRequiredUpdateInternalPrice':
        return $translate.instant('Please fill out start and end date.');
      case 'msgOpenInvoicesInTabsIsLimited':
        return $translate.instant(
          'The number of invoices you can open in separate tabs is limited to 10',
        );
      case 'msgCreateFileInBackgroundFailed':
        return $translate.instant(
          'Something went wrong while creating the file. Please try again later.',
        );
      case 'msgClickHereToDownloadDocument':
        return $translate.instant(
          'Your file is ready to download. Click here if this does not happen automatically.',
        );
      case 'msgDocumentReady':
        return $translate.instant('Document ready');
      case 'msgCouldNotFindInvoicePdf':
        return $translate.instant(
          'Invoice PDF could not be found. Please contact support if this problem persists.',
        );
      case 'msgInvalidEmailAddress':
        return $translate.instant('An invalid email address was entered.');
      case 'comfirmUnnumberInvoiceTitle':
        return $translate.instant('Unnumber invoice?');
      case 'comfirmUnnumberInvoiceMessage':
        return $translate.instant('Are you sure want to unnumber this invoice?');
      case 'msgInvoiceSuccessfullyUnnumbered':
        return $translate.instant('The invoice was successfully unnumbered');
      case 'comfirmUndoWriteOffInternallyTitle':
        return $translate.instant('Undo write off internally?');
      case 'comfirmUndoWriteOffInternallyMessage':
        return $translate.instant('Are you sure want to change this back to a draft invoice?');
      case 'EmailSent':
        return $translate.instant('Email sent');
      case 'MsgNoSigningProviderConfiguredSeeSettings':
        return $translate.instant(
          'No signing provider has been configured. You can configure a document signing provider under general settings.',
        );
      case 'msgRequiredDocumentSigner':
        return $translate.instant('Please select a signer for each required signature.');
      case 'msgRequiredDocumentCcSigner':
        return $translate.instant('Please select a CC');
      case 'msgDocumentSigningRequestSent':
        return $translate.instant('Request to sign document has been sent.');
      case 'msgDocumentSigningRequestFailed':
        return $translate.instant('Something went wrong while creating the signature request.');
      case 'msgDocumentSingingRequestRevoked':
        return $translate.instant('Document signature request was revoked.');
      case 'msgConfirmRevokeSignature':
        return $translate.instant('Are you sure you want to revoke the signature request?');
      case 'msgRequiredEnterpriseNumberAndAddress':
        return $translate.instant('Enterprise number and company address are mandatory.');
      case 'msgInvoicesWillBeMarkedAsSent':
        return $translate.instant('The selected invoices will be marked as sent shortly.');
      case 'msgIncludeNonBillableRegistrationsTitle':
        return $translate.instant('Include non billable registrations?');
      case 'msgDiscardCheckout':
        return $translate.instant(
          'Are you sure you want to discard this checkout? it is currently checked out by {{name}}?',
          params,
        );
      case 'msgIncludeNonBillableRegistrationsMsg':
        return $translate.instant(
          'Do you want to include non-billable registrations in the invoice detail?',
        );
      case 'confirmRevertDraftInvoices':
        return $translate.instant('Are you sure you want to revert these draft invoices?');
      case 'msgTaskTemplateHasAllAvailableRelationFields':
        return $translate.instant('This task template already has all available relation fields');
      case 'msgSelectTableColumns':
        return $translate.instant('Select which columns you want to display in the table');
      case 'msgConfirmChangeScheduleDateMessage':
        return $translate.instant(
          'The date you picked differse more than a month from the original date, are you sure you want to change this date? You can always create a support ticket if you feel like something is wrong with your invoice schedules.',
        );
      case 'msgInvoicesWillBeMarkedAsPaid':
        return $translate.instant(
          'The selected invoices will be marked as paid in the background.',
        );
      case 'msgTaskUserChangedError':
        return $translate.instant('Something went wrong while changing the assigned user.');
      case 'msgInvoiceExportStatusWillBeCleared':
        return $translate.instant(
          'The export status of the selected invoices will be cleared in the background.',
        );

      case 'msgConfirmLeavePage':
        return $translate.instant('Leave page?');
      case 'msgConfirmLeavePageMessage':
        return $translate.instant(
          'You changed something, leaving the page will discard the made changes.',
        );
      case 'msgInvoicesWillBeMarkedAsExported':
        return $translate.instant('The invoices will be marked as exported in the background.');
      case 'msgSelectionContainedAlreadyExportedInvoices':
        return $translate.instant(
          'The selection contained already exported invoices. These were not included in the export.',
        );
      case 'UploadSuccessful':
        return $translate.instant('Upload successful');

      case 'SearchCriteriaNameInputTitle':
        return $translate.instant('SearchCriteriaNameInputTitle');
      case 'SearchCriteriaNameInputMessage':
        return $translate.instant('SearchCriteriaNameInputMessage');
      case 'SearchCriteriaNameInputPlaceholder':
        return $translate.instant('SearchCriteriaNameInputPlaceholder');
      case 'msgConfirmDeleteRelationTag':
        return $translate.instant('Are you sure you want to delete this tag?');
      case 'msgOneOfInvoicesAlreadySent':
        return $translate.instant(
          'One of the selected invoices has already been sent. Do you want to continue?',
        );
      case 'msgConfirmDeleteActiveInvoiceScheduleWithDraftInvoices':
        return $translate.instant(
          'There is still a draft invoice that was created by this schedule. If you delete this schedule, the draft invoice will be deleted and the registrations will be moved back to open registrations. Are you sure you want to do this?',
        );
      case 'msgConfirmDeleteActiveInvoiceSchedule':
        return $translate.instant('Are you sure you want to delete this invoice schedule?');
      case 'msgConfirmDeleteNotificationsOfType':
        return $translate.instant('Do you also want to delete all notifications of this type?');
      case 'msgCompanyCreatedInEstox':
        return $translate.instant('The company was created as concept in eStox');
      case 'msgRecalcDeadlinesTitle':
        return $translate.instant('Recalculate task deadlines?');

      case 'msgRecalcDeadlinesMessage':
        return $translate.instant(
          'There are {{count}} planned tasks with a deadline based on the general meeting or end fiscal year. Do you want to recalculate the deadline of these tasks?',
          params,
        );
      case 'msgBatchUpdateRegistrationsSuccess':
        return $translate.instant('{{count}} registrations where updated.', params);
      case 'msgXTransactionsDeleted':
        return $translate.instant('{{p0}} transactions deleted', params);

      case 'msgInvoiceWillBeProcessedTonight':
        return $translate.instant(
          'The invoice will be processed tonight, using invoice date {{date}}',
          params,
        );
      case 'msgConfirmBillRegistrations':
        return $translate.instant(
          'Are you sure you want to add these registrations to draft invoices?',
        );
      case 'msgConfirmDeleteRegistrations':
        return $translate.instant(
          'Are you sure you want to delete these {{count}} registrations ?',
          params,
        );
      case 'msgConfirmLockRegistrations':
        return $translate.instant(
          'Are you sure you want to lock these {{count}} registrations ?',
          params,
        );
      case 'msgConfirmUnlockRegistrations':
        return $translate.instant(
          'Are you sure you want to unlock these {{count}} registrations ?',
          params,
        );
      case 'selectionContainsDocumentPendingOrAlreadySigned':
        return $translate.instant(
          'One or more documents selected is already awaiting signature or is already signed.',
        );
      case 'msgConfirmDeleteDocuments':
        return $translate.instant('Are you sure you want to delete these documents?');
      case 'msgTaskPlanningXSchedulesQueued':
        return $translate.instant(
          'The taskplanning was queued for {{count}} task schedules. The planning will run in the background and can take a few minutes to finish.',
          params,
        );
      case 'msgTaskPlanningNothingQueued':
        return $translate.instant(
          'There are no task schedules to be queued for this task template',
        );

      case 'comfirmUndoOrNeverSettledAdvanceLine':
        return $translate.instant(
          'Are you sure you want to delete this advance? Settle advance on next settlement or delete it forever and never settle it?',
        );
      case 'neverSettleAdvance':
        return $translate.instant('Delete advance and never settle it');
      case 'neverSettleAdvancesAndNeverInvoiceRegistrations':
        return $translate.instant('Never invoice advance(s) and registration(s) again');
      case 'msgEditInvoiceTwikeyWarning':
        return $translate.instant(
          'This invoice might already exist in Twikey. Please delete the invoice in Twikey before editing and saving this invoice, otherwise the payment info will be incorrect.',
        );
      case 'msgTransactionMovedToOpenTransactions':
        return $translate.instant('Transaction moved to open transactions');
      case 'msgArchiveTransactionExplanation':
        return $translate.instant(
          'Are you sure you want to delete this transaction? Since there are one or more payments linked to the transaction, it will be archived and moved to the closed transactions instead.',
        );
      case 'msgRequiredEmailSubjectAndBody':
        return $translate.instant('E-mail subject and body are required.');

      case 'msgRelationFoundOnPeppolNetwork':
        return $translate.instant(
          'The relation was found on the PEPPOL network. You can now send invoices to the PEPPOL network for this relation.',
        );
      case 'msgInvoiceSentViaPeppol':
        return $translate.instant('The invoice was sent to the PEPPOL network.');
      case 'msgRelationNotFoundOnPeppolNetwork':
        return $translate.instant('The relation was not found on the PEPPOL network');
      case 'msgRelationFoundOnPeppolNetworkButNoSupportedDocumentFormats':
        return $translate.instant(
          'The relation was found on the PEPPOL network, but does not support any invoice formats that are also supported by AdminPulse',
        );
      case 'msgSwitchInvoiceStrategyToPeppolAfterInvoiceSent':
        return $translate.instant(
          'The invoice was sent through the PEPPOL network. Do you want to switch the invoice strategy for this relation to PEPPOL?',
        );
      case 'msgSwitchInvoiceStrategyToPeppolAfterLookup':
        return $translate.instant(
          'The relation was found on the PEPPOL network. Do you want to switch the invoice strategy for this relation to PEPPOL?',
        );

      case 'msgInvoiceAlreadyExportedViaPeppol':
        return $translate.instant(
          'This invoice was already sent to the PEPPOL network. Are you sure you want to send it again?',
        );
      case 'msgDirectDebitInviteSent':
        return $translate.instant('Direct debit invite was sent to the customer.');
      case 'msgConfirmDeleteRelation':
        return $translate.instant('Are you sure you want to delete this relation?');
      case 'msgRelationSetToInactive':
        return $translate.instant(
          'Relation put inactive because registrations and/or invoices exist for this relation, or because this relation is linked to another relation file',
        );
      case 'msgSomeTaskSchedulesCouldNotBePlanned':
        return $translate.instant(
          'The task schedules were created, but there were some that could not plan the first task:',
        );
      case 'msgMandateCreatedInMollie':
        return $translate.instant('The mandate was created in Mollie');
      case 'comfirmUnnumberInvoiceMessagePaymentProvider':
        return $translate.instant(
          'Are you sure want to unnumber this invoice? If the customer has a direct debit mandate and the amount was already debited via your payment provider, you might have to manually refund this customer.',
        );
      case 'msgConfirmCleanupMonthsTitle':
        return $translate.instant('Are you sure you want to set the cleanup to {{value}}?', params);
      case 'msgConfirmCleanupMonths':
        return $translate.instant(
          'Because if you set it to {{value}}, {{count}} tasks will be removed by tomorrow.',
          params,
        );
      case 'msgConfirmCleanupMonthsAtLeast1000':
        return $translate.instant(
          'Because if you set it to {{value}}, at least 1000 tasks will be removed by tomorrow.',
          params,
        );
      case 'EditTaskTemplateRequiredDocumentTypes':
        return $translate.instant('Add or remove required document types');
      case 'registrationFormContainsErrors':
        return $translate.instant('The registration form contains errors');
      case 'msgConfirmDeleteTodo':
        return $translate.instant('Are you sure you want to delete this todo?');
      case 'msgConfirmTurnOffAbsenceCounter':
        return $translate.instant(
          'Are you sure you want to turn off the counter for this absence?',
        );
      case 'msgSomeLanguagesContainValidationErrors':
        return $translate.instant('Some languages contain validation errors');

      case 'msgCreateRelationGroup':
        return $translate.instant('Do you want to create the relation group {{value}}?', params);
      case 'msgCheckinWarning':
        return $translate.instant(
          'Something went wrong checking in the document, this could be caused by the document having been deleted in OneDrive. The checkout has been discarded instead.',
        );
      case 'msgCheckinSuccesfull':
        return $translate.instant('Successfully checked in file.');
      case 'msgConfirmDeleteRequiredAuthorization': {
        return $translate.instant('Are you sure you want to delete this authorization?');
      }
      case 'msgCheckedOutBy':
        return $translate.instant('Document is checked out by {{name}}', params);
      case 'confirmFinalizeNegativeInvoice':
        return $translate.instant(
          'Are you sure you want to finalize this negative invoice? If this is a creditnote, please use the button to convert it to a creditnote.',
        );
      case 'confirmFinalizePositiveCreditNote':
        return $translate.instant(
          'Are you sure you want to finalize this positive creditnote? If this is an invoice, please use the button to convert it to an invoice.',
        );
      case 'msgDraftInvoicesUnlocked':
        return $translate.instant('The selected draft invoices have been unlocked.');
      case 'msgDraftInvoicesLocked':
        return $translate.instant('The selected draft invoices have been locked.');
      case 'msgConfirmDeleteHoliday':
        return $translate.instant('Are you sure you want to delete bank holiday {{date}}?', params);
      case 'msgRegistrationsWillBeModifiedInTheBackground':
        return $translate.instant('The registrations will be modified in the background.', params);
      case 'msgRegistrationIsLockedForEdit':
        return $translate.instant('The registration is locked and cannot be modified.');
      case 'msgRegistrationIsLockedForDelete':
        return $translate.instant('The registration is locked and cannot be deleted.');
      case 'msgCannotSelectRelationForInvoices':
        return $translate.instant(
          'YouCannotSelectThisRelationBecauseYouDoNotHavePermissionToViewItsInvoices',
        );
      case 'msgCannotSelectRelationWithoutInvoiceStreams':
        return $translate.instant('YouCannotSelectThisRelationBecauseItHasNoInvoiceStreams');
      case 'msgPdfExportStarted':
        return $translate.instant('PDF export started, your file will be downloaded when ready');
        case 'msgExcelExportStarted':
        return $translate.instant('Excel export started, your file will be downloaded when ready');
        case 'msgWordExportStarted':
        return $translate.instant('Word export started, your file will be downloaded when ready');
      default:
        //Fallback try to translate
        return $translate.instant(msgString, params);
    }
  };
}
